


























































import { Vue, Component, Prop } from 'vue-property-decorator';
import PortalInput from "@/components/common/PortalInput.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import ServiceCatalogService from "@/services/ServiceCatalogService";
import { AddServiceCatalogItemPayload } from "@/dto/sales/catalog/ServiceCatalogItemDTO";
import { processError } from "@/utils/ComponentUtils";

@Component({
  components: { PortalInput, PortalTextarea }
})
export default class AddServiceCatalogItemModal extends Vue {
  @Prop() onSuccess!: () => void;

  private payload: AddServiceCatalogItemPayload = {
    title: '',
    description: '',
    priceCents: 0,
    subscriberPriceCents: null
  };

  private priceDollars = '';
  private subscriberPriceDollars = '';

  get isFormValid(): boolean {
    const price = parseFloat(this.priceDollars);
    return !!this.payload.title && !!this.payload.description && !isNaN(price) && price >= 0;
  }

  async submit() {
    if (this.$loadOn) this.$loadOn();
    try {
      this.payload.priceCents = Math.round(parseFloat(this.priceDollars) * 100);
      if (this.subscriberPriceDollars) {
        this.payload.subscriberPriceCents = Math.round(parseFloat(this.subscriberPriceDollars) * 100);
      } else {
        this.payload.subscriberPriceCents = null;
      }

      await ServiceCatalogService.addItem(this.payload);
      if ((this as any).$nts) (this as any).$nts.success("Service catalog item added");
      if (this.onSuccess) this.onSuccess();
      this.close();
    } catch (e) {
      processError(e, this);
    } finally {
      if ((this as any).$loadOff) (this as any).$loadOff();
    }
  }

  close() {
    (this as any).$modal.hideAll();
  }
}
